module.exports = __webpack_public_path__ + "img/SCIENCE_BG_pattern.873a26c0.svg";